import { Helmet } from "react-helmet-async";

const SITE_NAME = "HaasFab";
const SITE_URL = "https://haasfab.com";
const DEFAULT_DESCRIPTION =
  "HaasFab - Fabrication and Finishing in Ohio - Powder Coating, Cerakote, CNC Plasma Cutting, Welding, Metal Signs, 3D Printing, CAD Modeling";

const LOCAL_BUSINESS_JSON_LD = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: SITE_NAME,
  description: DEFAULT_DESCRIPTION,
  url: SITE_URL,
  telephone: "+1-419-806-9442",
  email: "business@haasfab.com",
  address: {
    "@type": "PostalAddress",
    addressLocality: "Bowling Green",
    addressRegion: "OH",
    addressCountry: "US",
  },
  areaServed: [
    {
      "@type": "GeoCircle",
      geoMidpoint: {
        "@type": "GeoCoordinates",
        latitude: 41.3745,
        longitude: -83.6513,
      },
      geoRadius: "40234",
    },
    { "@type": "City", name: "Bowling Green, OH" },
    { "@type": "City", name: "Toledo, OH" },
    { "@type": "City", name: "Perrysburg, OH" },
    { "@type": "City", name: "Maumee, OH" },
    { "@type": "City", name: "Findlay, OH" },
    { "@type": "City", name: "Fremont, OH" },
  ],
  sameAs: [
    "https://www.facebook.com/HaasFab-100925839159371",
    "https://www.instagram.com/haasfab_llc/",
  ],
};

function SEO({ title, description = DEFAULT_DESCRIPTION, path = "/" }) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const canonicalUrl = `${SITE_URL}${path === "/" ? "" : path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <script type="application/ld+json">
        {JSON.stringify(LOCAL_BUSINESS_JSON_LD)}
      </script>
    </Helmet>
  );
}

export default SEO;
